import type * as React from 'react';

import { cn } from '@/lib/utils';
import { type ButtonSize, type ButtonVariant, buttonVariants } from './button-variants';

type ButtonProps = React.ComponentProps<'button'> & {
    variant?: ButtonVariant;
    size?: ButtonSize;
};

export function Button({ className, variant, size, ...props }: ButtonProps) {
    return <button className={cn(buttonVariants({ variant, size }), className)} {...props} />;
}
